(function () {
  if (window.__imagesTextSliderReady) return;
  window.__imagesTextSliderReady = true;

  function initSlider(root) {
    if (!root || root.dataset.esInitialized === 'true') return;
    root.dataset.esInitialized = 'true';

    var viewport = root.querySelector('[data-es-viewport]');
    var track = root.querySelector('[data-es-track]');
    var btnPrev = root.querySelector('[data-es-prev]');
    var btnNext = root.querySelector('[data-es-next]');
    if (!viewport || !track || !btnPrev || !btnNext) return;

    var originalSlides = Array.prototype.slice.call(track.querySelectorAll('[data-es-slide]'));
    var originalCount = originalSlides.length;
    if (!originalCount) return;

    var perView = 3;
    var cloneCount = 3;
    var currentIndex = 0;
    var isAnimating = false;
    var resizeTimer = null;
    var slideWidth = 0;
    var gap = 0;

    function getGap() {
      return parseFloat(getComputedStyle(track).gap) || 0;
    }

    function getConfig() {
      var width = window.innerWidth;

      if (width <= 640) {
        return { perView: 1 };
      }

      if (width <= 989) {
        return { perView: 2, trailingPeek: 80 };
      }

      return { perView: 3, trailingPeek: 0 };
    }

    function calculateSlideWidth() {
      var config = getConfig();
      var viewportWidth = viewport.clientWidth;
      gap = getGap();

      if (config.perView === 1) {
        return viewportWidth;
      }

      if (config.perView === 2) {
        return (viewportWidth - gap - config.trailingPeek) / 2;
      }

      return (viewportWidth - (gap * 2)) / 3;
    }

    function applySlideWidths() {
      slideWidth = calculateSlideWidth();

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-es-slide]'));
      slides.forEach(function (slide) {
        slide.style.width = slideWidth + 'px';
        slide.style.minWidth = slideWidth + 'px';
        slide.style.maxWidth = slideWidth + 'px';
        slide.style.flexBasis = slideWidth + 'px';
      });

      var total = slides.length;
      var trackWidth = (total * slideWidth) + ((total - 1) * gap);
      track.style.width = trackWidth + 'px';
    }

    function getStep() {
      return slideWidth + gap;
    }

    function clearClones() {
      track.querySelectorAll('.is-clone').forEach(function (node) {
        node.remove();
      });
    }

    function buildClones() {
      clearClones();

      var config = getConfig();
      perView = config.perView;
      cloneCount = Math.min(originalCount, perView);

      var baseSlides = Array.prototype.slice.call(track.querySelectorAll('[data-es-slide]:not(.is-clone)'));

      baseSlides.slice(-cloneCount).map(function (slide) {
        var clone = slide.cloneNode(true);
        clone.classList.add('is-clone');
        return clone;
      }).forEach(function (clone) {
        track.insertBefore(clone, track.firstChild);
      });

      baseSlides.slice(0, cloneCount).map(function (slide) {
        var clone = slide.cloneNode(true);
        clone.classList.add('is-clone');
        return clone;
      }).forEach(function (clone) {
        track.appendChild(clone);
      });

      applySlideWidths();
      currentIndex = cloneCount;

      requestAnimationFrame(function () {
        jumpTo(currentIndex);
      });
    }

    function jumpTo(index) {
      track.style.transition = 'none';
      track.style.transform = 'translate3d(' + (-index * getStep()) + 'px, 0, 0)';
    }

    function animateTo(index) {
      track.style.transition = 'transform .45s ease';
      track.style.transform = 'translate3d(' + (-index * getStep()) + 'px, 0, 0)';
    }

    function goTo(index) {
      if (isAnimating) return;
      isAnimating = true;
      currentIndex = index;
      animateTo(currentIndex);
    }

    btnPrev.addEventListener('click', function () {
      goTo(currentIndex - 1);
    });

    btnNext.addEventListener('click', function () {
      goTo(currentIndex + 1);
    });

    track.addEventListener('transitionend', function () {
      isAnimating = false;

      if (currentIndex >= originalCount + cloneCount) {
        currentIndex = cloneCount;
        jumpTo(currentIndex);
      }

      if (currentIndex < cloneCount) {
        currentIndex = originalCount + cloneCount - 1;
        jumpTo(currentIndex);
      }
    });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildClones();
      }, 120);
    });

    var startX = 0;
    var deltaX = 0;
    var dragging = false;

    viewport.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      startX = event.touches[0].clientX;
      deltaX = 0;
      dragging = true;
      track.style.transition = 'none';
    }, { passive: true });

    viewport.addEventListener('touchmove', function (event) {
      if (!dragging || !event.touches || !event.touches.length) return;
      deltaX = event.touches[0].clientX - startX;
      track.style.transform = 'translate3d(' + ((-currentIndex * getStep()) + deltaX) + 'px, 0, 0)';
    }, { passive: true });

    viewport.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;

      var threshold = 50;

      if (deltaX > threshold) {
        goTo(currentIndex - 1);
      } else if (deltaX < -threshold) {
        goTo(currentIndex + 1);
      } else {
        animateTo(currentIndex);
      }
    });

    buildClones();
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-es-root]')) {
      initSlider(context);
    }
    context.querySelectorAll('[data-es-root]').forEach(initSlider);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
